export const RolesEndpoints = {
  list: `roles`,
  permissionList: `permissions`,
  post: `roles`,
  update: (id?: number) => `roles?id=${id}`,
  permission: {
    get: (role_id?: string | number) => `role/permissions?role_id=${role_id}`,
    patch: (role_id?: string | number) => `role/permissions?role_id=${role_id}`
  }
}
